<template>
  <v-ons-page id="app">
    <v-ons-splitter>
      <v-ons-splitter-side
        swipeable
        side="left"
        collapse
        :animation="$ons.platform.isAndroid() ? 'overlay' : 'reveal'"
        :open.sync="menuIsOpen"
      >
        <menu-page></menu-page>
      </v-ons-splitter-side>
      <v-ons-splitter-content>
        <transition name="fade-transform" mode="out-in">
          <!-- <keep-alive> -->
          <!-- <router-view></router-view> -->
          <router-view :key="key" />

          <!-- </keep-alive> -->
        </transition>
      </v-ons-splitter-content>
    </v-ons-splitter>

    <v-ons-modal :visible="$store.state.onsen.modalVisible">
      <p class="text-center">
        Loading
        <v-ons-icon icon="fa-spinner" spin></v-ons-icon>
      </p>
    </v-ons-modal>
    <v-ons-toast
      class="toast-error"
      :visible="$store.state.onsen.toastVisible"
      animation="fall"
      animationOptions="timeout: 0.2"
      >{{ $store.state.onsen.toastMessage }}</v-ons-toast
    >

    <!-- versionxx {{appVersion}} -->
  </v-ons-page>
</template>

<script>
import MenuPage from "./components/MenuPage";
import { async } from "q";
import Vue from "vue";

export default {
  name: "App",
  data: function() {
    return {
      cordova: Vue.cordova
      // appVersion: process.env.APP_VERSION
    };
  },
  computed: {
    menuIsOpen: {
      get() {
        return this.$store.state.onsen.open;
      },
      set(newValue) {
        this.$store.dispatch("onsen/updateToggle", newValue);
      }
    },
    key() {
      return this.$route.path;
    },
    cordovaIsClosedApp() {
      return this.$store.state.utilsCordova.closeApp;
    }
  },
  components: {
    MenuPage
  },
  watch: {
    async $route(to, from) {
      // console.log('this.$route.path: '+this.$route.path)
      // react to route changes...
      if (this.$route.path === "/" || this.$route.path === "/home") {
        await this.$store.dispatch("utilsCordova/updateCloseApp", true);
      } else {
        await this.$store.dispatch("utilsCordova/updateCloseApp", false);
      }
    }
  },
  methods: {
    pressBackButton() {
      if (this.cordovaIsClosedApp === true) {
        //tampilkan pesan closed jka from = /
        // this.$ons.notification
        //   .confirm("Do you want to close the app?") // Ask for confirmation
        //   .then(function(index) {
        // if (index === 1) {
        // OK button
        navigator.app.exitApp(); // Close the app
        // }
        // });
      } else {
        // alert('value: '+this.cordovaIsClosedApp)
        window.history.back();
      }
    },
    onDeviceReady() {
      Vue.cordova.on("backbutton", () => {
        this.pressBackButton();
      });
      // Add similar listeners for other events
    }
  },
  mounted() {
    // listen to Cordova event
    Vue.cordova.on("deviceready", () => {
      this.onDeviceReady();
      navigator.splashscreen.show();
      setTimeout(function() {
        navigator.splashscreen.hide();
      }, 2000);
    });
  },
  beforeDestroy() {
    window.removeEventListener("deviceready", this.onDeviceReady);
    window.removeEventListener("backbutton", this.pressBackButton);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ons-splitter-side[side="left"][animation="overlay"] {
  border-right: 0px solid #bbb;
}
</style>
<style>
@font-face {
  font-family: "SF Pro Display";
  src: url("//db.onlinewebfonts.com/t/0b51833ff62e4af8acb5fd3e2bf59e97.eot");
  src: url("//db.onlinewebfonts.com/t/0b51833ff62e4af8acb5fd3e2bf59e97.eot?#iefix")
      format("embedded-opentype"),
    url("//db.onlinewebfonts.com/t/0b51833ff62e4af8acb5fd3e2bf59e97.woff2")
      format("woff2"),
    url("//db.onlinewebfonts.com/t/0b51833ff62e4af8acb5fd3e2bf59e97.woff")
      format("woff"),
    url("//db.onlinewebfonts.com/t/0b51833ff62e4af8acb5fd3e2bf59e97.ttf")
      format("truetype"),
    url("//db.onlinewebfonts.com/t/0b51833ff62e4af8acb5fd3e2bf59e97.svg#SF Pro Display")
      format("svg");
}
body {
  font-family: "SF Pro Display" !important;
}
hr.hr-dashed-2 {
  /* border-top: 0.75px dashed #e0e0e0; */
  border-top: 0px dashed #bdbdbd;
  border-bottom: 0.75px dashed #bdbdbd;
}
/* ios */
.button {
  background-color: #50b755 !important;
}
.text-input {
  background-image: linear-gradient(to top, transparent 1px, #afafaf 1px);
  background-size: 100% 2px;
  background-repeat: no-repeat;
  background-position: center bottom;
}
.page__background {
  background-color: inherit !important;
  /* background-color: #eeeeee; */
  /* background-image: url("assets/ifacare/Background2.png") !important; */
  /* background-position: bottom !important;
  background-repeat: no-repeat !important;
  background-size: cover !important; */
  /* background-color: linear-gradient(120deg#2cba80 0%, #73b063 25%, #96aa53 50%, #aea54a 75%, #d59f3b 100%) !important; */
}
.page__content {
  background-color: inherit !important;
}
.page--wrapper > .page__background {
  display: block;
}
ons-splitter-side .page__content {
  top: 0 !important;
}
.toolbar-button {
  color: #464646;
}
.toolbar__title {
  font-weight: 600;
}
.toast-error .toast {
  background-color: #c62828;
}
.footer-toast .toast__message {
  margin: 0;
}
.footer-toast .toast {
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  background-color: transparent;
  min-height: auto;
}
/* and ios */
.card-link:hover,
.card-link:focus {
  background-color: rgb(234, 255, 235) !important;
  display: block;
}
.card {
  overflow: hidden;
  position: relative;
}
.position-relative {
  position: relative;
  z-index: 2;
}
.card .card-link-bottom:hover::after {
  content: "";
  width: 100%;
  position: absolute;
  background-color: rgb(234, 255, 235) !important;
  display: block;
  height: 65px;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.card .card-link-top:hover::after {
  content: "";
  width: 100%;
  position: absolute;
  background-color: rgb(234, 255, 235) !important;
  display: block;
  height: 65px;
  top: 0;
  left: 0;
  z-index: 1;
}
.card .card-link-left:hover::after {
  content: "";
  width: 50%;
  position: absolute;
  background-color: rgb(234, 255, 235) !important;
  display: block;
  height: 100%;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.card .card-link-right:hover::after {
  content: "";
  width: 50%;
  position: absolute;
  background-color: rgb(234, 255, 235) !important;
  display: block;
  height: 100%;
  bottom: 0;
  right: 0;
  z-index: 1;
}
.dot-space {
  width: 4px;
  height: 4px;
  background-color: #757575;
  border-radius: 50%;
  margin: 0 1px 2px 1px;
  display: inline-table;
  vertical-align: middle;
}
.bg-grey-soft {
  background-color: #bdbdbd;
}
.bg-grey {
  background-color: #757575;
}
ons-toast.toast-error .toast--material {
  background-color: #c62828;
}
.content-spinner {
  margin: 0 !important;
  text-align: center;
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  background-color: #ffffff;
  padding: 10px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  z-index: 3;
}
.d-flex-icon {
  display: flex;
}
.d-flex {
  display: flex;
}
.d-flex-icon ons-icon {
  margin-right: 3px;
}
.border-right-dotted-grey {
  border-right: 1px dotted #bdbdbd;
}
.button--material {
  background-color: #50b755 !important;
}
.text-right {
  text-align: right;
}
.footer-toast .toast--material {
  padding: 0;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.2);
  color: #ffffff;
}
.font-weight-normal {
  font-weight: normal;
}
.font-weight-light {
  font-weight: 300;
}
.padding-16 {
  padding: 8px 15px;
}
.opacity-8 {
  opacity: 0.8;
}
.bg-success {
  background-color: #50b755;
}
.bg-success-dark {
  background-color: #4ba54f;
}
.content-grand-total-footer {
  font-size: 15px;
  font-weight: 600;
}
.content-show-data {
  font-size: 12px;
  color: #ffffff;
}
.footer-toast .toast--material__message {
  margin: 0;
}
.content-medium-no-data {
  font-size: 13px;
  display: block;
  color: #9e9e9e;
  top: 50%;
  position: relative;
}
.btn-to-top {
  /* position: fixed;
  text-align: center;
  right: 15px;
  top: auto; */
  bottom: 40px;
  z-index: 4;
  /* padding: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
  color: rgba(0, 0, 0, 0.5); */
}
.label-info-range-date {
  color: #757575 !important;
  font-weight: 500 !important;
}
.list-item__center {
  /* /* line-height: 1em; */
  line-height: 2em;
}
.ons-icon.fa-spinner[spin] {
  color: #50b755;
}
.text-white {
  color: #ffffff !important;
}
.text-grey-soft {
  color: #9e9e9e !important;
}
.text-grey {
  color: #757575 !important;
}
.text-grey-dark {
  color: #616161 !important;
}
.text-grey-darker {
  color: #424242 !important;
}
.text-dark {
  color: #000000 !important;
}
.expandable-custom {
  padding: 0 14px 14px 14px;
  margin-top: -10px;
}
.f-right {
  float: right;
}
.content-checkbox {
  font-size: 14px;
}
.font-size-12 {
  font-size: 12px;
}
.font-size-14 {
  font-size: 14px;
}
.font-size-15 {
  font-size: 15px;
}
.font-size-16 {
  font-size: 16px;
}
.font-size-17 {
  font-size: 17px;
}
.font-size-18 {
  font-size: 18px;
}
.icon-no-data {
  font-size: 20px;
}
.label-list-parent {
  font-size: 14px;
  font-weight: 600;
}
.label-list-parent-small {
  font-size: 13px;
  font-weight: 600;
}
.label-list-child {
  font-size: 12px;
  font-weight: 400;
  color: #757575;
}
.label-list-childest {
  font-size: 11px;
  font-weight: 400;
  color: #757575;
}
.flex-colon {
  display: flex;
}
.flex-colon span.span-colon {
  display: inline-block;
  margin-right: 5px;
}
.space-list {
  margin-bottom: 5px;
}
.bg-no-data {
  background-color: #eeeeee;
  position: absolute;
  height: 100%;
  top: 0;
  width: 100%;
}
.list-item-right-icon-top .list-item__right {
  align-items: start;
}
.m-r-min {
  margin-right: -25px;
}
.p-y-mini-card {
  padding-left: 5px;
  padding-right: 5px;
}
.align-items-center {
  align-items: center;
}
ons-list.frame-filter {
  margin-bottom: 5px;
  z-index: 1;
  position: relative;
}
ons-list.space-bottom {
  margin-bottom: 5px;
}
.list-item-box-search {
  border: 1px solid #bdbdbd;
  border-bottom: 1px solid #bdbdbd !important;
  border-radius: 5px;
  margin: 10px;
}
.list-item-box-search .expandable-content {
  padding: 0 16px 16px;
}
.list-item-box-search.list-item {
  width: auto;
}
.list-item-box-search .list-item__center,
.list-item-box-search .list-item__right {
  padding: 5px 10px !important;
  min-height: 35px;
}
ons-splitter-content {
  box-shadow: none !important;
}

.toolbar-dasboard {
  display: flex;
  justify-content: space-between;
}

.toolbar-dasboard .toolbar__left,
.toolbar-dasboard .toolbar__title,
.toolbar-dasboard .toolbar__right {
  display: none;
}

.toolbar-dasboard .toolbar-left {
  width: 50%;
  display: flex;
  align-items: center;
}

.toolbar-dasboard .toolbar-left .text-menu {
  padding-left: 10px;
}

.toolbar-dasboard .toolbar-right {
  display: flex;
  align-items: center;
  padding-right: 15px;
}

.toolbar-dasboard .toolbar-right .fa {
  color: #fff;
  font-size: 17px;
}

.toolbar-dasboard .toolbar-right .fa-user {
  width: 21px;
  height: 21px;
  text-align: end;
  background: #eefff8;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eaeaea;
  border-radius: 50%;
  font-size: 15px;
  color: #53b56f;
  margin-left: 15px;
}

/* ons-splitter-content {
  transform: translate3d(0px, 0px, 0px) !important;
} */

ons-splitter-side {
  z-index: 9 !important;
}
/* .page__content {
  overflow: initial;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue